import React from 'react';
import { FilterBar } from '@opendate-app/setlist';

const flatten = (filterGroups) =>
  filterGroups.reduce((all, g) => all.concat(g.filters), []).map((f) => ({ ...f, key: f.id }));

function DealsFilterBar({ filterGroups, activeFilters, onChange, resultCount }) {
  const filters = React.useMemo(() => flatten(filterGroups), [filterGroups]);

  return (
    <FilterBar
      variant="plain"
      filters={filters}
      values={activeFilters}
      onChange={onChange}
      resultCount={resultCount}
    />
  );
}

export default DealsFilterBar;
